import NextImage, { ImageProps } from 'next/image';

const customLoader = ({
  src,
  width,
  quality
}: {
  src: string;
  width: string | number;
  quality?: number;
}) => {
  if (width) return `${src}?w=${width}&q=${quality || 13}`;
  return `${src}?q=${quality || 13}`;
};

function Image({
  src,
  alt,
  width,
  height,
  priority,
  placeholderImgURL
}: {
  src: any;
  alt: string;
  width?: number;
  height?: number;
  priority?: boolean;
  placeholderImgURL?: string;
}) {
  const props: ImageProps = {
    priority,
    src: src.src || src,
    height,
    width,
    alt,
    placeholder: placeholderImgURL ? 'blur' : undefined,
    blurDataURL: placeholderImgURL,
    layout: !height && !width ? 'fill' : undefined,
    style: {}
  };

  if (src && typeof src === 'string' && src.indexOf('si.') !== -1) {
    props.unoptimized = true;
    props.loader = (loaderProps) => loaderProps.src;
  } else props.loader = customLoader;

  return <NextImage {...props} />;
}

Image.defaultProps = {
  priority: false,
  placeholderImgURL: null,
  height: undefined,
  width: undefined
};

export default Image;
